/* NetworkDiscoveryGridViewComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
//const UserGridData = require('@gluenetworks/entity_grid_gl').UserData;
const Renderer = require("./NetworkDiscoveryGridViewRenderer");
const Registrations = require("../../../../../RegistrationNamespaces");

const DateColumn = require("./column_renderers/date/DateComponent");
// const SentenceCaseColumn = require("./column_renderers/sentense_case/SentenceCaseComponent");
const SearchTypeColumn = require("./column_renderers/search_type/SearchTypeComponent");
const ModeColumn = require("./column_renderers/mode/ModeComponent");

const PagingNetworkDiscoveryFeed = require("./PagingNetworkDiscoveryFeed");

const _ = require("lodash");

class NetworkDiscoveryGridViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        userSession,
        storageFactory,
        solutionsManager,
        modalUserFeedback,
        EngineZone,
        OrgZone
    ) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._modalUserFeedback = modalUserFeedback;
        this._solutionsManager = solutionsManager;
        this._engineZoneEntityDef = EngineZone;
        this._orgZoneEntityDef = OrgZone;

        this._solutionName =
            (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "networkDiscoveryExplorer";
        this._storageFactory = storageFactory;
        this._userGridData = undefined;
        this._networkDiscoveryEntityDef = this._gameEditor._NetworkDiscoveryEntityDef;
        this._pagingNetworkDiscoveryFeed = undefined;
        this._renderer = new Renderer(this);
        this._explorerState = {
            selectedIds: [],
        };
        this.columns = undefined;
        this._sessionStorage = undefined;
        //this._sessionStorage = new UserGridData(`${this._gridKey}_explorerState`, null, { storageKey: 'deviceExplorer_explorerState', storageType: 'session' });
    }

    get columnConfig() {
        const optionMode = {};
        Object.keys(this._networkDiscoveryEntityDef.getModeValues()).forEach(
            (mode) =>
                (optionMode[mode] = {
                    name: mode,
                    title: mode.camelize(),
                })
        );

        const optionStatus = {};
        Object.keys(this._networkDiscoveryEntityDef.getStatusValues()).forEach(
            (status) =>
                (optionStatus[status] = {
                    name: status,
                    title: status.camelize(),
                })
        );

        const optionSearchType = {};
        const labelsSearchType = this._networkDiscoveryEntityDef.getSearchTypeLabels();
        Object.keys(labelsSearchType).forEach(
            (searchType) =>
                (optionSearchType[searchType] = {
                    name: searchType,
                    title: labelsSearchType[searchType],
                })
        );

        if (this.columns) {
            return this.columns;
        }
        this.columns = {
            name: {
                label: "Name",
                priority: 1,
                shown: true,
            },
            description: {
                label: "Description",
                priority: 2,
                shown: true,
            },
            mode: {
                label: "Mode",
                priority: 3,
                shown: true,
                options: optionMode,
                columnRendererComponent: ModeColumn,
            },
            ipRanges: {
                label: "Ranges",
                priority: 4,
                shown: true,
            },
            status: {
                label: "Status",
                priority: 8,
                shown: true,
                // columnRendererComponent: SentenceCaseColumn,
                options: optionStatus,
            },
            zoneName: {
                label: "Engine Zone",
                priority: 9,
                shown: false,
            },
            searchType: {
                label: "Search Type",
                priority: 10,
                shown: false,
                options: optionSearchType,
                columnRendererComponent: SearchTypeColumn,
                context: this._networkDiscoveryEntityDef.getSearchTypeLabels(),
            },
            useArp: {
                label: "Use ARP",
                priority: 11,
                shown: false,
            },
            useCdp: {
                label: "Use CDP",
                priority: 12,
                shown: false,
            },
            useLldp: {
                label: "Use LLDP",
                priority: 13,
                shown: false,
            },
            vrf: {
                label: "VRF",
                priority: 14,
                shown: false,
            },
            lastRunOn: {
                label: "Last Run",
                priority: 15,
                shown: true,
                columnRendererComponent: DateColumn,
            },
            createdOn: {
                label: "Created On",
                priority: 16,
                shown: false,
                columnRendererComponent: DateColumn,
                // dataType: "datetime"
            },
            createdBy: {
                label: "Created By",
                priority: 17,
                shown: false,
            },
            updatedOn: {
                label: "Updated On",
                columnRendererComponent: DateColumn,
                priority: 18,
                // dataType: "datetime"
            },
            updatedBy: {
                label: "Updated By",
                priority: 19,
            },
        };

        return this.columns;
    }

    get pagingFeed() {
        return this._pagingNetworkDiscoveryFeed;
    }

    get selectedRows() {
        return this._renderer.selectedRows;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        // this._solutionsManager.on(
        //     "activeSolutionChanged",
        //     (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        // );
    }

    _unregisterListeners() {
        // this._solutionsManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
    }

    _patchSorting(sorting) {
        // add second sorting order by name
        if (
            sorting &&
            Object.keys(sorting).length === 1 &&
            !sorting.name &&
            this.columnConfig.name
        ) {
            sorting.name = 1;
        }
    }

    _registerFeedListeners() {}

    _unregisterFeedListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    whenModelIsReady() {
        return this._gameEditor
            .whenInitialized()
            .then(() => {
                return this._storageFactory.whenStorageIsReady();
            })
            .then(() => {
                this._userGridData = this._storageFactory.getRemoteStorageInstanceForEntityGrid(
                    "entity_grid_gl",
                    this._gridKey
                );
                this._sessionStorage = this._storageFactory.getSessionStorageInstance(
                    "entity_grid_gl",
                    `${this._gridKey}_explorerState`
                );
                this._explorerState = Object.assign(
                    {},
                    this._explorerState,
                    this._sessionStorage.getData()
                );
            })
            .then(() => this._loadEngineZoneValues())
            .then((engineZoneValues) => {
                this._engineZoneValues = engineZoneValues;

                this.columnConfig.zoneName.options = this._engineZoneValues;
                this.columnConfig.zoneName.context = {zoneValues: this._engineZoneValues};
                this._pagingNetworkDiscoveryFeed = new PagingNetworkDiscoveryFeed({
                    feedKey: this._gridKey + "_feed",
                    userSession: this._userSession,
                    entityDef: this._networkDiscoveryEntityDef,
                    columnConfig: this.columnConfig,
                    filter:
                        _.get(this._userGridData.getBasicSearchData(), "filterQuery", {}) ||
                        this._userGridData.getAdvancedSearchData(),
                    sort: this._userGridData.getSorting(),
                    additionalDataFields: ["targets", "engineZoneId"],
                });

                this._registerListeners();
                return Promise.resolve();
            })
            .then(() => {
                return this.whenFeedIsReady();
            });
    }

    async _loadEngineZoneValues() {
        try {
            const _engineZoneValues = await this._engineZoneEntityDef.loadAscendEngineZones(
                _.get(this._userSession._activeOrganization, "id"),
                {},
                {}
            );

            const _orgZoneValues = await this._orgZoneEntityDef.loadAscendOrgZones(
                _.get(this._userSession._activeOrganization, "id"),
                {defaultZone: true},
                {}
            );

            this._defaultZoneId =
                _orgZoneValues.length > 0 ? _orgZoneValues[0].getEngineZoneId() : "";

            let _engineZoneDDValues = {};
            _engineZoneValues.forEach((engineZone) => {
                _engineZoneDDValues[engineZone.getDisplayName()] = {
                    title: engineZone.getDisplayName(),
                    name: engineZone.getId(),
                };
            });
            return _engineZoneDDValues;
        } catch (err) {
            return Promise.reject(err);
        }
    }

    wasFeedPreviouslyInitialized() {
        return this._pagingNetworkDiscoveryFeed.wasPreviouslyInitialized();
    }

    whenFeedIsReady() {
        return this._pagingNetworkDiscoveryFeed.whenFeedReady();
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterFeedListeners();
        this._unregisterListeners();
        let shutdowns = [
            _.isUndefined(this._renderer) ? Promise.resolve() : this._renderer.shutdown(),
            _.isUndefined(this._pagingNetworkDiscoveryFeed)
                ? Promise.resolve()
                : this._pagingNetworkDiscoveryFeed.shutdown(),
            _.isUndefined(this._sessionStorage)
                ? Promise.resolve()
                : this._sessionStorage.shutdown(),
        ];
        return Promise.all(shutdowns).then(
            () => {
                //this._gameEditor._unregisterDeviceExplorerListeners(); // Unregister game editor events
                // please avoid destroying parent components
                this._gameEditor = undefined;
                this._renderer = undefined;
                this._explorerState = undefined;
                this._pagingNetworkDiscoveryFeed = undefined;
                this._userSession = undefined;
                this._modalUserFeedback = undefined;
                this._solutionsManager = undefined;
                this._solutionName = undefined;
                this._gridKey = undefined;
                this._userGridData = undefined;
                this._sessionStorage = undefined;
                this._logger = undefined;
                this._engineZoneEntityDef = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "PlanGridViewComponent.shutdown() error");
            }
        );
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get explorerState() {
        return this._explorerState;
    }

    set explorerState(val) {
        this.setExplorerState(val);
    }

    setExplorerState(val) {
        this._explorerState = val;
    }

    updateExplorerState(property, val) {
        this._sessionStorage.setData(val, property);
        _.set(this._explorerState, property, val);
    }

    resetSelection(newIds) {
        let selectedIds = [];

        if (newIds && newIds.length) {
            newIds.forEach((id) => {
                selectedIds.push(id);
            });
        }

        this.renderer._planEntityGrid.setSelectedRows(selectedIds);
        this.updateExplorerState("selectedIds", {selectedRows: selectedIds});
        this.renderer._renderAvailableActions();
    }

    loadAndScrollTo(entityId) {
        let that = this;
        this.pagingFeed.on("RequestedEntityFound", handleRequestedEntityFound);
        this.pagingFeed._requestEntity(entityId);

        function handleRequestedEntityFound(index) {
            that.renderer._planEntityGrid.renderer.scrollToTheRow(index);
            that.pagingFeed.removeListener("RefreshView", handleRequestedEntityFound);
        }
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    onUserSorted(sortData) {
        let sort = {};

        const sortCriteria =
            this.columnConfig[sortData.sortColumn].valuePath ||
            this.columnConfig[sortData.sortColumn].path ||
            sortData.sortColumn;

        sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        this._patchSorting(sort);

        this._pagingNetworkDiscoveryFeed.setSort(sort);
    }

    _onSolutionChanged(solution) {
        // whole pane will be reset, no need to make any action here
        this._solutionName = solution.name;
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    openPlanInstanceEditor(ids, fullyQualifiedViewName) {
        ids = [].concat(ids);

        const id = ids[0];
        let Plan = this._pagingNetworkDiscoveryFeed.getNetworkDiscoveryEntityById(id);
        this._gameEditor.launchNetworkDiscoveryEditor(
            {
                fqn: fullyQualifiedViewName || Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_DETAILS,
            },
            {
                id: id,
                title: _.get(Plan, "name", ""),
            }
        );
    }

    getSelectedPlanIds() {
        return _.get(this._explorerState, "selectedIds", []);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = NetworkDiscoveryGridViewComponent;

NetworkDiscoveryGridViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.userSession",
    "$teve.storageFactory",
    "$teve.solutionsManager",
    "$teve.ui.userFeedback",
    "$teve.entities.EngineZone",
    "$teve.entities.OrgZone",
];

NetworkDiscoveryGridViewComponent.$displayDetails = {
    type: "View",
    name: "",
    icon: "common.duplicate",
    shown: false,
    order: 1,
};
